// to subtract from session_at set adding to true, because offsetMinutes is negative
export function changeTzToHours (session_at, adding = true) {
  const currentDate = new Date()
  // offsetMinutes is negative
  const offsetMinutes = currentDate.getTimezoneOffset()
  console.log(offsetMinutes)

  console.log('session_at', session_at)
  const times = session_at.split(':')
  console.log(times[0])
  let hours = adding
      ? Number(times[0]) + (offsetMinutes / 60)
      : Number(times[0]) - (offsetMinutes / 60)
  console.log(hours)
  if (hours < 0) {
    hours = hours + 24
  }
  if (hours > 23) {
    hours = hours - 24
  }
  if (hours.toString().length < 2) {
     hours = '0' + hours
  }
  console.log(hours)
  return hours + ":" + times[1]
}
export function getConditionComparisonBinaryOpList () {
  return [
    { text: "", value: null },
    { text: "И", value: "AND" },
    { text: "ИЛИ", value: "OR" },
  ]
}

// export function getComparisonItems(item) {
//   let obj = {};
//   if ("registration") {
//   }
// }

// export function getConditionComparisonOpList(value) {
//   let result = [];
//   switch (value) {
//     case "full":
//       result = [
//         { text: "Равно  =", value: "==" },
//         { text: "Больше или Равно  >=", value: ">=" },
//         { text: "Меньше или Равно  <=", value: "<=" },
//         { text: "Больше  >", value: ">" },
//         { text: "Меньше  <", value: "<" },
//         { text: "Не равно  <>", value: "!=" },
//       ];
//       break;
//
//     case "middle":
//       result = [
//         { text: "Равно  =", value: "==" },
//         { text: "Не равно  <>", value: "!=" },
//       ];
//       break;
//     case "weak":
//       result = [{ text: "Равно  =", value: "==" }];
//       break;
//   }
//   console.log("result=" + JSON.stringify(result));
//   return result;
//   // if (full) {
//   //   return [
//   //     { text: "Равно  =", value: "==" },
//   //     { text: "Больше или Равно  >=", value: ">=" },
//   //     { text: "Меньше или Равно  <=", value: "<=" },
//   //     { text: "Больше  >", value: ">" },
//   //     { text: "Меньше  <", value: "<" },
//   //     { text: "Не равно  <>", value: "!=" },
//   //   ];
//   // } else {
//   //   return [
//   //     { text: "Равно  =", value: "==" },
//   //     { text: "Не равно  <>", value: "!=" },
//   //   ];
//   // }
// }

// export function getConditionParameterList() {
//   return [
//     { text: "Регистрация", value: "registration" },
//     { text: "Код товара", value: "product_code" },
//     { text: "Дети", value: "children" },
//     { text: "Сумма", value: "amount" },
//     { text: "Фиксированная дата", value: "fixed_date" },
//     { text: "День рождения", value: "birthday" },
//     // { text: "Точка обслуживания", value: "point" },
//   ]
// }

export function getObjectsForSearching (objs, searching) {
  return objs.filter(item => {
    return Object.values(item).map(m => {
          return m ? m.toString().includes(searching) : false
        }
    ).some(s => { if (s) return item })
  })
}

export function getRuleAccrualTypeList () {
  return [
    { text: "Проценты (%)", value: 0 },
    { text: "Условные единицы (у.е.)", value: 1 },
    { text: "Цена товара", value: 2 },
  ]
}

export function getRuleChargeTypeList () {
  return [
    { text: "Транзакционный", value: 0 },
    { text: "Регулярный", value: 1 },
  ]
}

export function getRuleOperationTypeList () {
  return [
    {
      text: "Покупка",
      value: 0,
    },
    {
      text: "Платёж",
      value: 1,
    },
    {
      text: "Регистрация",
      value: 2,
    },
    {
      text: "Регулярный",
      value: 3,
    },
  ]
}

export function getSearchedObjects (objs, searched_word) {
  // Get array objects like [{searched: obj1}, {searched: obj2}]
  return objs.map(m => {
    return Object.values(m).filter(f => {
      if (f !== null && f !== undefined) {
        if (f.toString().includes(searched_word)) {
          return f
        }
      }
    })
  }).filter(fl => fl.length > 0).map(mp => { return { searched: mp[0] } })
}

export function getUserProfileGenderList () {
  return [
    { text: "Мужской", value: 1 },
    { text: "Женский", value: 0 },
    { text: "Любой", value: 2 },
  ]
}

export function showSnackbar (store, text, color) {
  store.dispatch("snackbar_store/showSnackbar", {
    text: text,
    color: color,
  })
}

export function downloadCsvFile (nameCsvFile, contentFileCsv) {
  const hiddenElement = document.createElement("a")
  hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(contentFileCsv)
  hiddenElement.target = "_blank"
  hiddenElement.download = nameCsvFile
  hiddenElement.click()
}

export function downloadImageFile (nameImageFile, contentImage) {
  const hiddenElement = document.createElement("a")
  hiddenElement.href = "data:image/jpg;base64," + encodeURI(contentImage)
  hiddenElement.target = "_blank"
  hiddenElement.download = nameImageFile
  hiddenElement.click()
}

export function getCsvFile (arrObjects) {
  let csv = ""
  arrObjects.forEach(obj => {
    csv += obj.toCsv()
  })
  // arrObjects.map(m => Object.values(m).reduce((acc, value) => { return acc = acc + value + ';' }, '')
  return csv
}

export function guid () {
  function s4 () {
    return Math.floor(Math.random() * 65536).toString(16).padStart(4, '0')
  }
  return s4() + s4() + '-' + s4() + '-' + "4" + s4().substring(1) + '-' + s4() + '-' + s4() + s4() + s4()
}
// true: undefined, null, "", [], {}
// false: true, false, 1, 0, -1, "foo", [1, 2, 3], { foo: 1 }
export function isBlank (value) {
  return (
      // null or undefined
      (value == null) ||
      // has length and it's zero
      (value.hasOwnProperty('length') && value.length === 0) ||
      // is an Object and has no keys
      (value.constructor === Object && Object.keys(value).length === 0)
  )
}

export function isNotExists (value) {
  return (typeof value === "undefined" || value === null)
}

export function tryGet (item) {
  try {
    const test = item
    console.log('item', item)
    return item
  } catch (e) {
    return ''
  }
}

export function setScreenBackground (background) {
  console.log('SetScreenBackground', background)
  const elements = document.getElementsByClassName('v-application--wrap')
  if (elements.length > 0) {
    const el = elements[0]

    // Проверяем, начинается ли строка с префикса Base64 изображения
    const isBase64Image = background.startsWith('data:image')

    if (isBase64Image) {
      // Сбрасываем цвет и устанавливаем Base64 как фон
      el.style.backgroundColor = ''
      el.style.backgroundImage = `url("${background}")`
      el.style.backgroundSize = 'cover'
      el.style.backgroundPosition = 'center'
      el.style.backgroundRepeat = 'no-repeat'
    } else {
      // Если передали обычный цвет
      el.style.backgroundImage = ''
      el.style.backgroundColor = background
    }
  }
}

export function setScreenBackgroundById (elementId, background) {
  console.log('SetScreenBackgroundById', background)
  const element = document.getElementById(elementId)
  if (!element || !background) return

  // Проверяем, начинается ли строка с префикса Base64 изображения
    const isBase64Image = background.startsWith('data:image')

    if (isBase64Image) {
      // Сбрасываем цвет и устанавливаем Base64 как фон
      element.style.backgroundColor = ''
      element.style.backgroundImage = `url("${background}")`
      element.style.backgroundSize = 'cover'
      element.style.backgroundPosition = 'center'
      element.style.backgroundRepeat = 'no-repeat'
    } else {
      // Если передали обычный цвет
      element.style.color = getContrastTextColor(background)
      element.style.backgroundImage = ''
      element.style.backgroundColor = background
    }
}

// Метод принимает строку типа 'имя переменной'
export function getValueByVariableName (context, path) {
  // Если пути нет или он не строка, возвращаем undefined
  if (!path || typeof path !== 'string') return undefined

  // Начинаем перебор с переданного context (вместо ключевого слова this)
  return path.split('.').reduce((obj, key) => {
    return obj ? Reflect.get(obj, key) : undefined
  }, context)
}

// Метод принимает строку типа 'имя переменной' и новое значение
export function updateValueByVariableName (context, path, newValue) {
  const parts = path.split('.')

  // Доходим до предпоследнего элемента (до объекта dialogEditor)
  const targetObj = parts.slice(0, -1).reduce((obj, key) => {
    return obj ? Reflect.get(obj, key) : undefined
  }, context) // <-- Используем context

  // Последний элемент — это имя самого свойства
  const targetKey = parts[parts.length - 1]

  // Обновляем значение с сохранением реактивности Vue
  if (targetObj) {
    // В Vue 2 для сохранения реактивности используем context.$set
    context.$set(targetObj, targetKey, newValue)
  } else {
    console.error(`Не удалось найти объект по пути: ${path}`)
  }
}

// 🔥 Автоматически вычисляем контрастный цвет текста
export function getContrastTextColor(backgroundColor) {
  // 1. Создаем временный элемент для конвертации любых цветов (red, rgb, hsl) в стандартный RGB
  const tempElem = document.createElement('div')
  tempElem.style.color = backgroundColor
  document.body.appendChild(tempElem)

  // Получаем строку вида "rgb(r, g, b)"
  const rgbStr = window.getComputedStyle(tempElem).color
  document.body.removeChild(tempElem)

  // 2. Извлекаем числа R, G, B с помощью регулярного выражения
  const rgbValues = rgbStr.match(/\d+/g)
  if (!rgbValues) return '#000000' // Сводный дефолт (черный)

  const r = parseInt(rgbValues[0], 10)
  const g = parseInt(rgbValues[1], 10)
  const b = parseInt(rgbValues[2], 10)

  // 3. Формула YIQ для расчета человеческого восприятия яркости
  // Зеленый цвет кажется нам самым ярким, а синий — самым темным
  const yiq = (r * 299 + g * 587 + b * 114) / 1000

  // 4. Если яркость >= 128, фон светлый -> возвращаем черный текст. Иначе — белый.
  return yiq >= 128 ? '#000000' : '#FFFFFF'
}
